import React from "react";
import MdaeButton from "../button";
import { IDataGridActionEllipsisProps, IMdaeActionEllipsisOtherConfigsWithDispatch, IMdaeActionEllipsisOtherConfigsWithoutDispatch } from "./index";
import "./index.scss";
import {SET_GENERIC_DATAGRID_SELECTED_ROW_ID} from "../../mdae-common-reducer"

const MdaeDataGridActionEllipsis: React.FC<IDataGridActionEllipsisProps> = (
  props
) => {
  return (
    <div className={"sys-mdae-data-grid-action-ellipsis"}>
      <MdaeButton
        id={props.buttonId}
        className={props.className}
        role={"dxButton"}
        stylingMode={"text"}
        onClick={() => {
          props.onClick(props.cellInfo);
        }}
      >
        <div id={props.divId}>
          <div style={{ textAlign: "center" }}>
            <i
              className={"fas fa-ellipsis-h mdae-datagrid-action-ellipsis-icon"}
            ></i>
          </div>
        </div>
      </MdaeButton>
    </div>
  );
};

export const getDataGridActionEllipsisComponent = (
  e,
  otherConfig:
    | IMdaeActionEllipsisOtherConfigsWithoutDispatch
    | IMdaeActionEllipsisOtherConfigsWithDispatch
) => {
  const targetElementClass =
    "mdae-action-ellipsis-target-element-" + otherConfig?.entityId;
  return (
    <MdaeDataGridActionEllipsis
      className={targetElementClass}
      cellInfo={e}
      divId={
        otherConfig.entityName + "-list-row-action-" + otherConfig.entityId
      }
      buttonId={
        "btn-" +
        otherConfig.entityName +
        "-dataGridAction" +
        otherConfig.entityId
      }
      onClick={() => {
        switch (otherConfig.type) {
          case "usingDispatch":
            e.component.selectRowsByIndexes([e.row.rowIndex]);
            otherConfig.dispatch({
              type: SET_GENERIC_DATAGRID_SELECTED_ROW_ID,
              genericDataGridSelectedRowId: otherConfig.entityId,
            });
            break;
          default:
            otherConfig.currentRowDataUpdater(otherConfig.currentRowData);
            break;
        }

        otherConfig.showActionPopover(
          true,
          ".dx-datagrid-content-fixed ." + targetElementClass,
          otherConfig
        );
      }}
    ></MdaeDataGridActionEllipsis>
  );
};

export default MdaeDataGridActionEllipsis;
